module.exports = __webpack_public_path__ + "static/media/Flow.3eafafbf.png";